module.exports = "/images/vessel-1.jpg";